import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-361">
      <div className="max-w-4xl mx-auto text-center" data-id="element-362">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-[#39FF14]/50 text-[#39FF14] font-bold text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-363">
          🏆 Sistema N°1 para Docentes de Português en Argentina
        </div>

        <h2 className="text-4xl sm:text-5xl font-black text-white mb-4" data-id="element-364">
          🇧🇷 PROFEPACK™
        </h2>
        <h3 className="text-2xl sm:text-3xl font-bold text-[#39FF14] mb-6" data-id="element-365">
          MEGAPACK PORTUGUÊS LISTO
        </h3>
        <p className="text-white text-lg max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-366">
          <strong data-id="element-367">
            6 Tomos + 6 Bonos — Primaria + Secundaria — Todo resuelto.
          </strong>
          <br data-id="element-368" />
          540 páginas de contenido curricular completo. Solucionario en cada
          tomo. Planificación anual lista para presentar. Listo para usar desde
          hoy.
        </p>

        {/* Mockup visual */}
        <div className="relative mx-auto mb-10 max-w-2xl" data-id="element-369">
          <div className="grid grid-cols-6 gap-2 justify-center" data-id="element-370">
            {['#1565C0', '#2E7D32', '#E65100', '#6A1B9A', '#37474F', '#BF360C'].map((color, i) => {
            const labels = ['1°P', '2°P', '3°S', '4°S', '5°S', '6°S'];
            return <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2" style={{
              backgroundColor: color,
              border: '2px solid #39FF14'
            }} data-id="element-371">
                  <span className="text-white text-xs font-bold" style={{
                textShadow: '0 1px 3px rgba(0,0,0,0.8)'
              }} data-id="element-372">
                    {labels[i]}
                  </span>
                </div>;
          })}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#39FF14] text-black font-black text-xs px-4 py-1 rounded-full whitespace-nowrap" data-id="element-373">
            6 TOMOS COMPLETOS
          </div>
        </div>

        {/* Pills */}
        <div className="flex flex-wrap items-center justify-center gap-3 mt-8" data-id="element-374">
          <span className="bg-[#39FF14]/10 border border-[#39FF14]/40 text-[#39FF14] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-375">
            ✅ Por nivel (Primaria + Secundaria)
          </span>
          <span className="bg-[#39FF14]/10 border border-[#39FF14]/40 text-[#39FF14] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-376">
            ✅ Con planificación anual lista
          </span>
          <span className="bg-[#39FF14]/10 border border-[#39FF14]/40 text-[#39FF14] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-377">
            ✅ Con solucionario completo
          </span>
          <span className="bg-[#39FF14]/10 border border-[#39FF14]/40 text-[#39FF14] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-378">
            ✅ Con evaluaciones y rúbricas
          </span>
          <span className="bg-[#39FF14]/10 border border-[#39FF14]/40 text-[#39FF14] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-379">
            ✅ Con bonos incluidos
          </span>
          <span className="bg-[#39FF14]/10 border border-[#39FF14]/40 text-[#39FF14] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-380">
            ✅ Con conexión cultural Brasil-Argentina
          </span>
          <span className="bg-[#39FF14]/10 border border-[#39FF14]/40 text-[#39FF14] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-381">
            ✅ Falsos Amigos integrados en todos los niveles
          </span>
        </div>
      </div>
    </section>;
}